import { Module } from "@/constants";
import { useSettlementId } from "@/modules/projects/hooks/useSettlementId";
import { ProjectSettlementService } from "@/modules/projectSettlements/service/projectSettlements";
import { useQuery } from "@tanstack/react-query";

export const useSettlementQuery = () => {
  const settlementId = useSettlementId();

  return useQuery({
    queryKey: [Module.ProjectSettlements, settlementId] as const,
    queryFn: () => ProjectSettlementService.get(settlementId),
  });
};
